<template>
  <div
    :class="[
      'asc-top-navbar--container',
      isCollapsed ? 'asc-top-navbar--collapsed' : null,
    ]"
  >
    <v-app-bar dense class="asc-top-navbar--toolbar">
      <v-toolbar-title>
        <div class="asc-top-navbar--title">
          <span>Ascentia</span>
          <span class="asc-top-navbar--registered">&#xae;</span>
        </div>
      </v-toolbar-title>
      <asc-bread-crumbs :items="getBreadcrumbs"></asc-bread-crumbs>
      <v-spacer></v-spacer>
      <template v-if="globalFilterVisible">
        <asc-global-filter-button
          v-if="isGlobalFilterButtonVisible"
          :on-click="onManageGaf"
          :button-text="globalFilterText"
          :button-tooltip="globalFilterTooltip"
          :filter-active="globalFilterActive"
          :filter-enabled="globalFilterEnabled"
          :filter-disabled="globalFilterDisabled"
        ></asc-global-filter-button>
      </template>
      <asc-notifications-button
        v-if="isNotificationsButtonVisible"
        class="asc-top-navbar--button"
        :primary-items="notifications.primaryLinks"
        :secondary-items="notifications.secondaryLinks"
      ></asc-notifications-button>
      <asc-user-account-button
        :on-log-out="onLogOut"
        :profile="profile"
      ></asc-user-account-button>
    </v-app-bar>
  </div>
</template>

<script>
import AscNotificationsButton from '@/components/atoms/AscNotificationsButton'
import AscUserAccountButton from '@/components/atoms/AscUserAccountButton'
import AppFeatureFlags from '@/utilities/appFeatureFlags'
import AscGlobalFilterButton from '@/components/molecules/AscGlobalFilterButton'
import AscBreadCrumbs from '@/components/atoms/AscBreadcrumbs'
import { BreadcrumbsApi } from '@/utilities/breadcrumbsApi'

export default {
  name: 'AscTopNavbar',

  components: {
    AscNotificationsButton,
    AscUserAccountButton,
    AscBreadCrumbs,
    AscGlobalFilterButton,
  },

  props: {
    notifications: {
      type: Object,
      default: () => {
        return {
          primaryLinks: [],
          secondaryLinks: [],
        }
      },
    },
    collapsed: {
      type: Boolean,
      default: true,
    },
    onSizeChange: {
      type: Function,
      required: true,
    },
    onManageGaf: {
      type: Function,
      default: () => {},
    },
    featureFlags: {
      type: Object,
      default: () => {},
    },
    globalFilterText: {
      type: String,
      default: '',
    },
    globalFilterTooltip: {
      type: String,
      default: '',
    },
    globalFilterActive: {
      type: Boolean,
      default: false,
    },
    globalFilterEnabled: {
      type: Boolean,
      default: false,
    },
    globalFilterDisabled: {
      type: Boolean,
      default: false,
    },
    globalFilterVisible: {
      type: Boolean,
      default: false,
    },
    onLogOut: {
      type: Function,
      default: () => {},
    },
    profile: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      isCollapsed: this.collapsed,
    }
  },

  computed: {
    getBreadcrumbs() {
      const breadcrumbs = new BreadcrumbsApi(this.$route)
      return breadcrumbs.getBreadcrumbs()
    },

    isGlobalFilterButtonVisible() {
      return AppFeatureFlags.getNavGlobalFilterButton()
    },

    isNotificationsButtonVisible() {
      return AppFeatureFlags.getNavNotificationsButton()
    },
  },

  watch: {
    collapsed(newValue) {
      this.isCollapsed = newValue
    },
  },

  methods: {
    handleCollapse() {
      this.isCollapsed = !this.isCollapsed
      this.onSizeChange(this.isCollapsed)
    },
  },
}
</script>

<style lang="scss">
.asc-top-navbar--container {
  position: fixed;
  left: $primary-navbar-width;
  right: 0;

  .v-toolbar__content,
  .v-toolbar__extension {
    padding-left: 0;
  }

  .v-toolbar {
    box-shadow: none !important;
  }

  .asc-top-navbar--toolbar {
    background-color: $gray-100 !important;

    .asc-top-navbar--title {
      margin-left: 16px;
      font-size: 26px;
      font-weight: 200;
      margin-top: 2px;
      letter-spacing: 0.5px;

      .asc-top-navbar--registered {
        font-size: 13px;
        vertical-align: super;
      }
    }
  }

  .asc-top-navbar--button {
    margin-right: 16px;
  }
}

.asc-top-navbar--collapsed {
  left: 48px;
}
</style>
